import SearchableSelect from 'components/SearchableSelect/SearchableSelect';
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  searchableSelectContainer: {
    width: '200px',
    '@media (max-width: 504px)': {
      width: '100%',
    },
    '@media(max-width: 600px)': {
      flexGrow: 1
    }
  },
}));



const SearchableSelectProjectFilter = ({ onChange, ...props }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(null);

  const handleChange = (event, option) => {
    setValue(option);
    onChange(event, option?.value);
  };

  /**
   * When the component is mounted, we want to clear the value
   * so that the filter is reset to empty
   */
  useEffect(() => {
    onChange('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ marginTop: 0, marginRight: -8, marginBottom: 0, marginLeft: 8 }} className={classes.searchableSelectContainer}>
      <SearchableSelect
        getOptionSelected={(option, value) => option.name === value.name}
        value={value}
        onChange={handleChange}
        {...props}
      />
    </div>
  );
};

export default SearchableSelectProjectFilter;
